const formatKeys = {
    number: 'number',
    percent: 'percent',
    currency: 'currency',
    date: 'date',
    quarter: 'quarter',
    boolean: 'boolean',
    array: 'array',
    string: 'string',
    ids: 'ids'
};

const metrics = {
    GroupBy: {
        titleKey: 'day',
        isSortable: true,
        Hour: {
            format: formatKeys.date,
            dateType: 'dateTime',
            title: 'Hour'
        },
        Day: {
            format: formatKeys.date,
            title: 'Day'
        },
        Week: {
            format: formatKeys.date,
            dateType: 'dateWeek',
            title: 'Week'
        },
        Month: {
            format: formatKeys.date,
            dateType: 'dateMonth',
            title: 'Month'
        },
        Quarter: {
            format: 'quarter',
            title: 'Quarter'
        },
        Year: {
            format: formatKeys.date,
            dateType: 'dateYear',
            title: 'Year'
        },
        WeekDay: {
            format: formatKeys.date,
            dateType: 'dateWeekDay',
            title: 'WeekDay'
        },
        DayHour: {
            format: '',
            title: 'DayHour'
        },
        Offer: {
            format: formatKeys.ids,
            title: 'Offer'
        },
        Goal: {
            format: formatKeys.ids,
            title: 'Goal'
        },
        GoalEntry: {
            format: '',
            title: 'GoalEntry'
        },
        GoalAction: {
            format: '',
            title: ''
        },
        Link: {
            format: formatKeys.ids,
            title: 'Link'
        },
        UtmMedium: {
            format: formatKeys.ids,
            title: 'UtmMedium'
        },
        UtmSource: {
            format: formatKeys.ids,
            title: 'UtmSource'
        },
        UtmCampaign: {
            format: formatKeys.ids,
            title: 'UtmCampaign'
        },
        UtmTerm: {
            format: formatKeys.ids,
            title: 'UtmTerm'
        },
        UtmContent: {
            format: formatKeys.ids,
            title: 'UtmContent'
        },
        Param1: {
            format: '',
            title: 'Param1'
        },
        Param2: {
            format: '',
            title: 'Param2'
        },
        Param3: {
            format: '',
            title: 'Param3'
        },
        Param4: {
            format: '',
            title: 'Param4'
        },
        Param5: {
            format: '',
            title: 'Param5'
        },
        Param6: {
            format: '',
            title: 'Param6'
        },
        Param7: {
            format: '',
            title: 'Param7'
        },
        Param8: {
            format: '',
            title: 'Param8'
        },
        Param9: {
            format: '',
            title: 'Param9'
        },
        Country: {
            format: formatKeys.ids,
            title: 'Country'
        },
        Rejected: {
            format: formatKeys.boolean,
            title: 'Rejected',
            values: [
                {value: '0', title: 'No'},
                {value: '1', title: 'Yes'}
            ]
        },
        DeviceType: {
            format: '',
            title: 'DeviceType',
            values: [
                {value: 'mobile', title: 'mobile'},
                {value: 'tablet', title: 'tablet'},
                {value: 'desktop', title: 'desktop'}
            ]
        },
        DeviceOs: {
            format: '',
            title: 'DeviceOs',
            values: [
                {value: 'android', title: 'android'},
                {value: 'ios', title: 'ios'},
                {value: 'windows', title: 'windows'}
            ]
        },
        RefererDomain: {
            format: '',
            title: 'RefererDomain'
        },
        RefererSignificantSubdomain: {
            format: '',
            title: 'RefererSignificantSubdomain'
        },
        RefererPath: {
            format: '',
            title: 'RefererPath'
        },
        RefererPage: {
            format: '',
            title: 'RefererPage'
        },
        CreativeType: {
            format: formatKeys.ids,
            title: 'CreativeType'
        },
        CreativeId: {
            format: formatKeys.ids,
            title: 'CreativeId'
        },
        CreativeLinkId: {
            format: formatKeys.ids,
            title: 'CreativeLinkId'
        },
        CreativeContainerId: {
            format: formatKeys.ids,
            title: 'CreativeContainerId'
        },
        CreativeBannerId: {
            format: formatKeys.ids,
            title: 'CreativeBannerId'
        },
        CreativeLandingId: {
            format: formatKeys.ids,
            title: 'CreativeLandingId'
        },
        CreativePromoCodeId: {
            format: formatKeys.ids,
            title: 'CreativePromoCodeId'
        }
    },
    Visits: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    Visitors: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    ActionTypeSaleCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'sales',
        visible: true,
        isSortable: true
    },
    ActionNameVerifiedCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'verified',
        visible: true,
        isSortable: true
    },
    ActionNameRegCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'regs',
        visible: true,
        isSortable: true
    },
    ActionNameReactivationCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'reactivations',
        visible: false,
        isSortable: true
    },
    ConversionRatioToRegConfirmed: {
        format: formatKeys.percent,
        titleKey: 'reg',
        visible: true,
        isSortable: true
    },
    PublisherEarnPerClickAmountNew: {
        format: formatKeys.currency,
        titleKey: 'open',
        isSortable: true
    },
    PublisherEarnPerClickAmountRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
        isSortable: true
    },
    PublisherEarnPerClickAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'epc',
        visible: true,
        isSortable: true
    },
    SaleSumNew: {
        format: formatKeys.currency,
        titleKey: 'open',
        isSortable: true
    },
    SaleSumRejected: {
        format: formatKeys.currency,
        titleKey: 'cancelled',
        isSortable: true
    },
    FirstPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'FTDsCount',
        visible: true,
        isSortable: true
    },
    FirstPaymentCountRejected: {
        format: formatKeys.number,
        titleKey: 'FTDsRejectedCount',
        visible: true,
        isSortable: true
    },
    TotalPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'totalCount',
        visible: true,
        isSortable: true
    },
    FirstPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'FTDsSum',
        visible: true,
        isSortable: true
    },
    TotalPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'totalSum',
        visible: true,
        isSortable: true
    },
    FirstPaymentCountReview: {
        format: formatKeys.number,
        titleKey: 'FTDsCount',
        visible: false,
        isSortable: true
    },
    FirstPaymentSumReview: {
        format: formatKeys.currency,
        titleKey: 'FTDsSum',
        visible: false,
        isSortable: true
    },
    PublisherCommissionPerLeadAmountReview: {
        format: formatKeys.currency,
        titleKey: 'FTDsCommission',
        visible: false,
        isSortable: true
    },
    FirstPaymentCountHold: {
        format: formatKeys.number,
        titleKey: 'FTDsCount',
        visible: false,
        isSortable: true
    },
    FirstPaymentSumHold: {
        format: formatKeys.currency,
        titleKey: 'FTDsSum',
        visible: false,
        isSortable: true
    },
    PublisherCommissionPerLeadAmountHold: {
        format: formatKeys.currency,
        titleKey: 'FTDsCommission',
        visible: false,
        isSortable: true
    },
    TracksGGRAggregateConfirmed: {
        format: formatKeys.currency,
        titleKey: 'GGRaggregate',
        visible: false
    },
    PublisherAnnouncedTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'announcedCommission',
        visible: true
    },
    PublisherCreditTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'total',
        visible: true,
        isSortable: true
    },
    CreativeTypeConfirmed: {
        format: formatKeys.array,
        titleKey: 'type'
    },
    CreativeIdTitleConfirmed: {
        format: formatKeys.array,
        titleKey: 'title'
    }
};

const treeMetric = [
    [
        {
            config: {
                key: 'groups',
                metrics: ['GroupBy']
            }
        },
        {
            config: {
                key: 'traffic',
                metrics: ['Visits', 'Visitors']
            }
        },
        {
            config: {
                key: 'actions',
                metrics: ['ActionTypeSaleCountConfirmed', 'ActionNameVerifiedCountConfirmed', 'ActionNameRegCountConfirmed', 'ActionNameReactivationCountConfirmed']
            }
        },
        {
            config: {
                key: 'conversion',
                titleTemplate: '{{ title }} (CR)',
                metrics: ['ConversionRatioToRegConfirmed']
            }
        },
        {
            config: {
                key: 'regs',
                metrics: ['PublisherEarnPerClickAmountNew', 'PublisherEarnPerClickAmountRejected', 'PublisherEarnPerClickAmountConfirmed']
            }
        },
        {
            config: {
                key: 'sales',
                metrics: ['SaleSumNew', 'SaleSumRejected']
            }
        },
        {
            config: {
                key: 'deposit',
                metrics: ['FirstPaymentCountConfirmed', 'FirstPaymentCountRejected', 'TotalPaymentCountConfirmed', 'FirstPaymentSumConfirmed', 'TotalPaymentSumConfirmed']
            }
        },
        {
            config: {
                key: 'reviewFTD',
                metrics: ['FirstPaymentCountReview', 'FirstPaymentSumReview', 'PublisherCommissionPerLeadAmountReview']
            }
        },
        {
            config: {
                key: 'holdFTD',
                metrics: ['FirstPaymentCountHold', 'FirstPaymentSumHold', 'PublisherCommissionPerLeadAmountHold']
            }
        },
        {
            config: {
                key: 'commission',
                metrics: ['TracksGGRAggregateConfirmed', 'PublisherAnnouncedTotalAmountConfirmed', 'PublisherCreditTotalAmountConfirmed']
            }
        },
        {
            config: {
                key: 'creative',
                metrics: ['CreativeTypeConfirmed', 'CreativeIdTitleConfirmed']
            }
        }
    ]
];

export {
    formatKeys,
    metrics,
    treeMetric
};
